import React, { useState, useMemo } from 'react';
import DataTable from 'react-data-table-component';

const MyTableWithSearch = ({ columns, data }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredData = useMemo(() => {
    if (!searchTerm) return data;
    return data.filter(item =>
      Object.values(item).some(value =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [data, searchTerm]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // Memoize styles so they don’t cause re‑mounts
  const customStyles = useMemo(() => ({
    	headCells: {
		  style: {
			color:"white",
			background:"black",
			whiteSpace: "normal",
			wordBreak: "break-word",
			overflowWrap: "break-word",
			textAlign: "center",
			wrap :true
		  },
		},
  }), []);

  return (
    <div>
      <input
        type="text"
        placeholder="Recherche..."
        value={searchTerm}
        onChange={handleSearchChange}
        style={{ marginBottom: '10px', padding: '5px' }}
      />
      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        defaultSortFieldId="id"
        defaultSortAsc={true}
        customStyles={customStyles}
        className="datatable-header"
      />
    </div>
  );
};

export default MyTableWithSearch;